import { TipoOrdem } from "src/app/core/model/enum/tipo-ordem.enum";
import { Ordem } from "src/app/core/model/ordem";

export class OrdemUtils {
  static isTipoOrdem(ordem: Ordem, tipoEsperado: TipoOrdem): boolean {
    return ordem.tipoOrdem === tipoEsperado && 'dadosOrdem' in ordem;
  }

  static getAsTipo<T extends Ordem>(ordem: Ordem): T {
    return ordem as T;
  }
}
